module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/220-vietnam-b7fa992218d9a6da7c0428b643ead4fe.svg";